module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-contaier"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders.index',
        query: {
          filter: 'received'
        }
      }
    }
  }, [(_vm.loaded) ? _c('div', {
    staticClass: "waiting-received"
  }, [_c('div', {
    staticClass: "number-container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.number) + " "), _c('i', {
    staticClass: "el-icon-sold-out"
  })])])]) : _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0adcf40b","hasScoped":false}!./src/app/components/widgets/orderReceived/orderReceived.html
// module id = 2905
// module chunks = 1